// extracted by mini-css-extract-plugin
export default {"partNumber":"styles_partNumber__IN-kP"};